import * as Yup from "yup";
import { MAX_NAME_LENGTH, MIN_NAME_LENGTH } from "./const";

export const yupValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(
      MIN_NAME_LENGTH,
      `Your name has to be longer than ${MIN_NAME_LENGTH} characters!`
    )
    .max(
      MAX_NAME_LENGTH,
      `Your name has to be shorter than ${MAX_NAME_LENGTH} characters!`
    )
    .required("Your name is required!"),
  email: Yup.string()
    .email("Email is not valid!")
    .required("Email is required!")
});



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/signup/validationSchema-yup.js